export default __webpack_public_path__ + "static/media/zine-artwork4.49ae8731.jpg";